import { Button } from 'components/Button'
import Styles from './RemoveGuestModal.module.scss'
import { RemoveGuestWithBranchesProps } from './Types'
import { UnmergedBranchRow } from './UnmergedBranchRow'

const RemoveGuestWithBranches = ({
  guestName,
  branches,
  onRemoveAndDelete,
  onRemoveAndTransferOwnership,
}: RemoveGuestWithBranchesProps) => (
  <>
    <div className={Styles.body}>
      <div>
        Are you sure you want to remove the guest <b>{guestName}</b> from this workspace? They own {branches.length}{' '}
        linked copies, which you can choose to delete or transfer ownership to yourself.
      </div>
      <div className={Styles.branches}>
        {branches.map((b) => (
          <UnmergedBranchRow key={b.id} branch={b} />
        ))}
      </div>
    </div>
    <div className={Styles.actions}>
      <Button size="xl" className={Styles.removeAndDeleteBtn} variant="secondaryGrey" onPress={onRemoveAndDelete}>
        Remove & Delete
      </Button>
      <Button size="xl" onPress={onRemoveAndTransferOwnership}>
        Remove & Transfer Ownership to Me
      </Button>
    </div>
  </>
)

export { RemoveGuestWithBranches }
